import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

export enum FilterName {
  MODEL = 'model',
  AUTOPILOT = 'autopilot',
  RANGE = 'range',
  SEATS = 'seats',
  PRICE = 'price',
  MORE_FILTERS = 'more_filters',
  SORT_BY = 'sort_by',
}

export type Filter = {
  name: FilterName;
  options: any[];
  collapsed: boolean;
  selected: number | number[];
};

type Variables = {};
type Response = Filter[];

const fetchCarFilters = async (): Promise<Response> => {
  const response = await client.get('v2/cars/filters');

  const formattedData = response.data.data.map((filter: Filter) => {
    return {
      ...filter,
      selected: [],
    };
  });

  return [
    {
      name: FilterName.PRICE,
      options: [
        { name: 'Minimum', value: 10 },
        { name: 'Maximum', value: 1000 },
      ],
      collapsed: false,
      selected: [10, 1000],
    },
    ...formattedData,
    {
      name: FilterName.SORT_BY,
      options: [
        { name: 'Closest To Address', value: 'address' },
        { name: 'Price: High to Low', value: 'desc' },
        { name: 'Price: Low to High', value: 'asc' },
      ],
      collapsed: false,
      selected: 0,
    },
  ];
};

export const useCarFilters = createQuery<Response, Variables, AxiosError>({
  queryKey: ['car/filters'],
  fetcher: fetchCarFilters,
});
